var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "static-report-edit" },
    [
      _c("content-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function () {
              return [
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-3" },
                    [
                      _c("StaticReportRibbon", {
                        attrs: { serialNumberList: _vm.updateSnoList },
                        on: { "selection-details": _vm.updateComponents },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-end mr-3 mt-1" },
                    [
                      _c(
                        "button",
                        { staticClass: "btn", on: { click: _vm.openNewPage } },
                        [_vm._v(" " + _vm._s(_vm.$t("generateNewLink")) + " ")]
                      ),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _vm.isDataSelected
                  ? _c("ReportGrid", {
                      staticClass: "border",
                      attrs: {
                        isNewUi: _vm.isNewUi,
                        serialNumber: _vm.serialNumber,
                        asset: _vm.selectedAsset,
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }